import { createTheme } from "@mui/material";
import { merge } from 'lodash'
import { themeColors } from "./themeColors";
import { themeConfig } from './themeConfig'


export const techpathTheme = createTheme(merge({}, themeConfig, themeColors))